import { render, staticRenderFns } from "./jigsaw.vue?vue&type=template&id=30fc739e&scoped=true"
import script from "./jigsaw.vue?vue&type=script&lang=js"
export * from "./jigsaw.vue?vue&type=script&lang=js"
import style0 from "./jigsaw.vue?vue&type=style&index=0&id=30fc739e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc739e",
  null
  
)

export default component.exports